import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Select } from 'chakra-react-select';
import { Box } from '@chakra-ui/react';
import { useGetOCProfiles } from '../queries';
import { dropDownFormStyle } from 'components/forms/new/formStyles';
import { customSelectStyles } from '../constants';

const OCProfilesDropdown = ({ currentId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { darkMode } = useSelector((state) => state.settings);
    const { data: profiles, isLoading } = useGetOCProfiles();

    const handleChange = (option) => {
        if (option?.value) {
            navigate(
                `/operator-connect-profiles/${option.value}${location.search}`,
            );
        }
    };

    if (isLoading) return <span>Loading...</span>;

    const options =
        profiles?.map((p) => ({
            label: p.name,
            value: p.id,
        })) || [];

    const selectedOption = options.find((opt) => opt.value === currentId);
    const customStyles = dropDownFormStyle(darkMode);

    return (
        <Box minWidth="250px" display="inline-block">
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                menuPortalTarget={document.body}
                useBasicStyles
                chakraStyles={customSelectStyles(customStyles, darkMode)}
                isSearchable
                placeholder="Select Operator Profile"
                classNamePrefix="chakra-react-select"
            />
        </Box>
    );
};

export default OCProfilesDropdown;
